import { useState, useEffect, useRef, useCallback } from 'react';
import './style.scss'
import notCamera from '../../assets/licensePlate/not-camera.png'
import notScan from '../../assets/licensePlate/not-scan.png'
import { useSelector } from 'react-redux';
import { notification, Switch } from 'antd';
import { getExtensionLimitSettings, carRecognition } from "../../utils";
import { checkCamera } from '../../utils/cameraCheck';
import { InfoCircleFilled } from '@ant-design/icons';
import useBluetooth from '../../hooks/useBluetooth';
const colors = {
  blue: '蓝色',
  green: '绿色',
  yellow: '黄色',
  white: '白色',
  black: '黑色',
}
const initialPlateInfo = {
  color: '-',
  number: '-',
  vertexes_location: [],
}
const LicensePlate = () => {
  const debounceTimer = useRef(null);
  const [multiScale, setMultiScale] = useState(true);
  const [showBorder, setShowBorder] = useState(true);
  const [scanState, setScanState] = useState('');
  const [scanImage, setScanImage] = useState(null);
  const [plateInfo, setPlateInfo] = useState(initialPlateInfo);
  const [cameraError, setCameraError] = useState('');
  const [limitInfo, setLimitInfo] = useState({
    extension_id: '',
    one_day_limit: 0,
    any_minutes: 0,
    any_minutes_limit: 0,
    remain_nums: 0,
    can_use: true,
    next_use_time: '',
  })
  const bluetooth = useSelector(state => state.speaker.bluetooth);
  const video = useRef(null);
  const streamRef = useRef(null);
  const canvas = useRef(null);
  const tipCanvas = useRef(null);
  const requestInProgress = useRef(false);
  const onTipChange = (checked) => {
    setShowBorder(checked)
  }
  const { sendMessage, setupNotifications, stopNotifications } = useBluetooth();

  const onMessageReceived = (result) =>{
      // 使用防抖处理，避免频繁触发数据处理
      if (debounceTimer.current) {
        clearTimeout(debounceTimer.current);
      }
      debounceTimer.current = setTimeout(async () => {
        const data = result.find((item) => item.includes('plugin'));
        if (!data) {
          return;
        }
        const slice = data.split('//');
        const type = slice[1]
        console.log(type, 'type')
        if (type !== 'license_plate' && type !== 'all') return
        console.log('')
        console.log(`命令：${slice[2]}, uid：${slice[3]}`)
        const uid = slice[3]
        if(slice.includes('is_connect_ailab')){
          sendMessage({ [uid]: `${uid}_success` })
        }
        if (slice.includes('image_detection')) {
          setMultiScale(slice[4] == '1')
          sendMessage({ [uid]: `${uid}_success` })
        }
        if (slice.includes('video_scanning')) {
          takePhoto(uid);
        }
      }, 500);
  }
  const getExtensionLimit = async () => {
    try {
      let res = await getExtensionLimitSettings('licensePlate')
      setLimitInfo(res)
    } catch (error) {
      console.log('error', error);
    }
  }
  const takePhoto = useCallback(async (uid) => {
    // 检查网络连接状态
    if (!navigator.onLine) {
      notification.error({
        message: '错误',
        description: '你的网络存在问题或缺少该功能的使用权限。请稍后再试，或联系实验室管理员。',
      });
      sendMessage({ [uid]: `${uid}_error` });
      return;
    }
    requestInProgress.current = true
    let message = ''
    let type = ''
    let description = ''
    let responseTemplate = null
    const context = canvas.current.getContext('2d');
    context.drawImage(video.current, 0, 0, 320, 240);
    const image = canvas.current.toDataURL('image/jpeg');
    try {
      let res = await carRecognition({ image, multi_scale: multiScale })
      if (res.success) {
        const { data, message: msg, response_template } = res
        type = 'info'
        responseTemplate = response_template
        message = msg
        description = response_template.message
        if (data.words_result) {
          let { color, number, vertexes_location } = data.words_result
          const language = navigator.language || navigator.userLanguage;
          setPlateInfo({ color, number, vertexes_location })
          color = language.includes('zh') ? colors[color] : color
          sendMessage({ [uid]: { color, number } })
          setScanImage(image)
          setScanState('success')
        }
      } else {
        console.log('error---1', res);
      }
    } catch (error) {
      const { message: msg, response_template } = error.data
      type = 'error'
      message = msg
      responseTemplate = response_template
      description = response_template.message
      sendMessage({ [uid]: `${uid}_error` })
    }

    requestInProgress.current = false
    setLimitInfo(responseTemplate)
    notification[type]({
      message,
      description
    })

  }, [multiScale, bluetooth]);
  useEffect(() => {
    getExtensionLimit()
    checkCamera(video.current).then(async (res) => {
      if (res.available) {
        setCameraError('')
        streamRef.current = res.stream
        video.current.srcObject = res.stream;
        await video.current.play();
      } else {
        setCameraError(res.error)
        notification.error({
          message: '错误',
          description: res.error,
        })
      }
    })
    return () => {
      if (streamRef.current) {
        const tracks = streamRef.current.getTracks();
        tracks.forEach((track) => {
          track.stop();
        });
        streamRef.current = null; // 清理 MediaStream 的引用
      }
    }

  }, [])
  // 在组件加载时检查蓝牙连接状态并设置监听
  useEffect(() => {
    setupNotifications(onMessageReceived)
    return () => {
      stopNotifications(onMessageReceived)
    };
  }, [bluetooth]);
  useEffect(() => {
    if (tipCanvas.current) {
      const ctx = tipCanvas.current.getContext('2d');
      ctx.clearRect(0, 0, tipCanvas.current.width, tipCanvas.current.height);
      if (plateInfo.vertexes_location.length > 0) {
        const { vertexes_location } = plateInfo
        ctx.save();
        ctx.beginPath();
        ctx.moveTo(vertexes_location[0].x, vertexes_location[0].y);
        for (let i = 1; i < vertexes_location.length; i++) {
          ctx.lineTo(vertexes_location[i].x, vertexes_location[i].y);
        }
        ctx.closePath();
        ctx.lineWidth = 2;
        ctx.strokeStyle = 'yellow';
        ctx.stroke();
        ctx.restore();
      }
    }
  }, [plateInfo]);
  return (

    <div className='license-plate plug-in'>
      <div className='plug-in-name'>车牌识别</div>
      <div className='plug-in-content'>
        <div className='desc-content'>
          <div className='title'>车牌识别的原理：</div>
          <div className='desc-content'>
            当车辆经过时，摄像头会先拍下车牌照片，然后一般需要通过图像处理技术把照片调整得更清晰（比如去除反光、增强对比度）。<br />
            接着，系统会像拼拼图一样，先找到车牌——可能根据车牌的法定颜色、长方形的形状，或者边缘反光线条等特征来定位车牌在画面中的位置和大小。<br />
            找到车牌后，它会将车牌上的汉字、字母和数字逐个「剪开」，最后通过比对数据库中的字符模板，或者用一些特定的人工智能算法（如卷积神经网络），识别出每个字符，最后再组合成完整的车牌号码。
          </div>
          <div className='desc-content describe'>本扩展可在互联创作平台使用，或连接主控硬件后结合硬件编程平台使用。</div>
        </div>
        <div className='parameter'>
          <div className='parameter-content'>
            <div className='parameter-item'>
              <div className='name'>当前参数与摄像头画面</div>
              <div className='content'>
                {
                  cameraError ?
                    <div className='not-camera block'>
                      <div className='desc'>
                        <img src={notCamera} alt="" />
                        <div>没有找到摄像头</div>
                      </div>
                      <div className='tip'>
                        <div className='icon'><InfoCircleFilled /></div>
                        请允许浏览器调用摄像头（camera）
                      </div>
                    </div> :
                    <div className='camera block'>
                      <div className='desc'>
                        <video autoPlay id="video" ref={video} width={320} height={240}></video>
                        <canvas id="canvas" ref={canvas} width={320} height={240}></canvas>
                      </div>
                    </div>
                }
              </div>
            </div>
            <div className='parameter-item'>
              <div className='name'>最近一次扫描的画面与结果</div>
              <div className='content'>
                {
                  scanState ?
                    <div className='scanned block'>
                      <div className='desc'>
                        <img src={scanImage} alt="" />
                        <div className='border-tip' style={{ display: showBorder ? 'block' : 'none' }}>
                          <canvas ref={tipCanvas} width={320} height={240} style={{ position: 'absolute', left: 0, top: 0 }} />
                        </div>
                      </div>
                      <div className='tip'>
                        开启边界示意图？ <Switch size='small' checked={showBorder} onChange={onTipChange} />
                      </div>
                    </div> :
                    <div className='not-scan block'>
                      <div className='desc'>
                        <img src={notScan} alt="" />
                        <div>暂未进行过扫描</div>
                      </div>
                    </div>
                }
              </div>
            </div>
          </div>
        </div>

        <div className='result'>
          <div className='use-data'>
            <div className='mode'>检测模型：{multiScale ? '近距' : '远距'}</div>
            <div className='data'>当前账户每 {limitInfo.any_minutes} 分钟 {limitInfo.any_minutes_limit} 次，今日剩余 {limitInfo.remain_nums} 次。</div>
            {
              scanState && !limitInfo.can_use && <div className='next-time'>下一次扫描需等到 {limitInfo.next_use_time}</div>
            }

          </div>
          <div className='scan-data'>
            <div>车牌颜色：{colors[plateInfo.color] || '-'}</div>
            <div>车牌号码：{plateInfo.number}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LicensePlate;